var videoData = {    
    "videolist":[ 
        {
            id:1, 
            category: "Creation",
            embed:	"xwsUj-FUkgY",
            title:	"Material for Battery and Supercapacitors (graphitic carbon nitride)",
            postscript:	"Creation of graphitic carbon nitride using carbon, sugar and Urea",
            credit: "cayrex2",
            crediturl: "https://www.youtube.com/channel/UC6aKCXyrErIPKZNFEnYq0hw",
            keywords:	"Creation, Carbon Black, Urea" 
        },
        {
            id:2, 
            category: "Exfoliation",
            embed:	"lAFF_DctkIE",
            title:	"Material for Battery and Supercapacitors 2 (graphitic carbon nitride NANOSHEET)",
            postscript:	"Exfoliation of graphitic carbon nitride using acid and sonication",
            credit: "cayrex2",
            crediturl: "https://www.youtube.com/channel/UC6aKCXyrErIPKZNFEnYq0hw",
            keywords:	"Exfoliation, Sonication" 
        },
        {
            id:3, 
            category: "Hydrogen Generation",
            embed:	"Jj-nuTSjCBc",
            title:	"Graphitic Carbon Nitride - Hydrogen From The Sun",
            postscript:	"Creation and demonstration of g-C3N4 hydrocatalysis",
            credit: "Robert Murray-Smith",
            crediturl: "https://www.youtube.com/channel/UC4AkVj-qnJxNtKuz3rkq16A",
            keywords:	"Hydrogen Generation, Solar Energy" 
        },
        {
            id:4, 
            category: "Hydrogen Generation",
            embed:	"ztux9UnuNOg",
            title:	"DIY- GRAPHITE CARBON NITRIDE SOLAR HYDROGEN",
            postscript:	"Demonstration of H2 creation using gC3N4 foam with platinum",
            credit: "Peter Lang",
            crediturl: "https://www.youtube.com/channel/UC0HVVkEW_fHuOJFr3RepEiw",
            keywords:	"Hydrogen Generation, Solar Energy" 
        },
        {
            id:5, 
            category: "Hydrogen Generation",
            embed:	"18c_T5WnuhU",
            title:	"GRAPHITE CARBON NITRIDE SOLAR POWER!",
            postscript:	"Demonstration of H2 creation using gC3N4 with solar parabola",
            credit: "Peter Lang",
            crediturl: "https://www.youtube.com/channel/UC0HVVkEW_fHuOJFr3RepEiw",
            keywords:	"Hydrogen Generation, Solar Energy" 
        }
    ]
}
export default videoData


// WEBPACK FOOTER //
// ./src/data/videosjson.js